/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';

/**
 * Dynamic component mixin.
 *
 * Allows an inheriting service to include components dynamically.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component
export default class DynamicComponent extends Vue {
    public component: any = false;

    /**
     * Template property getter.
     *
     * This should be overriden in component injection classes.
     *
     * @returns {string}
     */
    public get template(): string {
        return '';
    }

    /**
     * Fallback function that loads the empty component.
     *
     * @returns {Promise<any>}
     */
    public fallback(): Promise<any> {
        return import('@/mixins/DynamicComponent/Empty');
    }

    /**
     * Dynamically load component.
     *
     * @returns {any}
     */
    public loader(): () => Promise<any> {
        if (!this.template) {
            return (): Promise<any> => this.fallback();
        }

        return (): Promise<any> => import(`@/${this.template}.vue`).catch(() => {
            return this.fallback();
        });
    }

    /**
     * Mounted life-cycle event.
     *
     * Initialises the loader.
     */
    public mounted(): void {
        this.component = this.loader();
    }
}

